var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 66,
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0C19.9721 0 11.4375 7.38731 11.4375 16.5C11.4375 25.6127 19.9721 33 30.5 33C41.0279 33 49.5625 25.6127 49.5625 16.5C49.5625 7.38731 41.0279 0 30.5 0ZM16.2031 16.5C16.2031 9.66548 22.6041 4.125 30.5 4.125C38.3959 4.125 44.7969 9.66548 44.7969 16.5C44.7969 23.3345 38.3959 28.875 30.5 28.875C22.6041 28.875 16.2031 23.3345 16.2031 16.5ZM8.10133 39.6C3.62808 39.6 3.90857e-05 42.7371 5.22658e-06 46.6107L0 47.85C0 54.0467 3.70132 58.6854 9.37907 61.6773C14.9623 64.6194 22.4672 66 30.5 66C38.5328 66 46.0377 64.6194 51.6209 61.6773C57.2987 58.6854 61 54.0467 61 47.85L61 46.6104C60.9999 42.7369 57.3719 39.6 52.8988 39.6H8.10133ZM4.76563 46.6107C4.76564 45.0169 6.25813 43.725 8.10133 43.725H52.8988C54.742 43.725 56.2343 45.0168 56.2344 46.6105L56.2344 47.85C56.2344 52.3783 53.6414 55.7833 49.1428 58.1539C44.5496 60.5743 37.9959 61.875 30.5 61.875C23.0041 61.875 16.4504 60.5743 11.8572 58.1539C7.35855 55.7833 4.76562 52.3783 4.76562 47.85L4.76563 46.6107Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user-logo.1065574df55da1a3a097bac0a7816296.svg";
export { ForwardRef as ReactComponent };